module.exports = __webpack_public_path__ + "static/360view_37m-cfdef90797d9adf2f88937a8de172140.jpg";